import { render, staticRenderFns } from "./dialog3.vue?vue&type=template&id=35a4d2d1&scoped=true"
import script from "./dialog3.vue?vue&type=script&lang=js"
export * from "./dialog3.vue?vue&type=script&lang=js"
import style0 from "./dialog3.vue?vue&type=style&index=0&id=35a4d2d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4d2d1",
  null
  
)

export default component.exports